import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgRadioSelected24 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" fillRule="evenodd" d="M16 27C9.92 27 5 22.08 5 16S9.92 5 16 5s11 4.92 11 11-4.92 11-11 11m0-21C10.48 6 6 10.48 6 16s4.48 10 10 10 10-4.48 10-10S21.52 6 16 6m0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3" clipRule="evenodd" /></SvgIcon>;
};
const Memo = memo(SvgRadioSelected24);
export default Memo;